import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "navbar navbar-expand-lg d-none d-lg-block main-nav" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "collapse navbar-collapse" };
const _hoisted_4 = {
    key: 0,
    class: "navbar-nav"
};
const _hoisted_5 = { class: "nav-item" };
const _hoisted_6 = ["src"];
const _hoisted_7 = { class: "collapse navbar-collapse justify-content-end" };
const _hoisted_8 = {
    key: 0,
    class: "navbar-nav"
};
const _hoisted_9 = { class: "nav-item" };
const _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.mainMenuEntriesLeft && _ctx.mainMenuEntriesLeft.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesLeft, (menuItem) => {
                            return (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                _createVNode(_component_g_link, {
                                    src: menuItem.actionCommand,
                                    target: menuItem.actionTarget,
                                    class: "nav-link"
                                }, {
                                    default: _withCtx(() => [
                                        (menuItem.iconUrl)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: menuItem.iconUrl
                                            }, null, 8, _hoisted_6))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["src", "target"])
                            ]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
                (_ctx.mainMenuEntriesRight && _ctx.mainMenuEntriesRight.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainMenuEntriesRight, (menuItem) => {
                            return (_openBlock(), _createElementBlock("li", _hoisted_9, [
                                _createVNode(_component_g_link, {
                                    src: menuItem.actionCommand,
                                    target: menuItem.actionTarget,
                                    class: "nav-link"
                                }, {
                                    default: _withCtx(() => [
                                        (menuItem.iconUrl)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: menuItem.iconUrl
                                            }, null, 8, _hoisted_10))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(menuItem.caption), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["src", "target"])
                            ]));
                        }), 256))
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ]));
}
